document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.js-header');
  const isDesktop = window.innerWidth > 991;
  const isMobile = window.innerWidth < 992;

  if (
    (isDesktop && document.querySelector('.js-invert-desktop-design')) ||
    (isMobile && document.querySelector('.js-invert-mobile-design'))
  ) {
    header?.classList.add('invert-design');
  }
});

window.addEventListener('scroll', function () {
  const header = document.querySelector('.js-header');
  if (!header) return;

  if (window.scrollY > 0) {
    header.classList.add('fixed');
  } else {
    header.classList.remove('fixed');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".js-header");

  if (header && header.parentNode) {
    const headerHeight = header.offsetHeight;

    header.parentNode.style.height = headerHeight + "px";
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.js-get-megamenu');

  targets.forEach(target => {
    const index = target.getAttribute('data-index');
    const source = document.querySelector(`.js-megamenu[data-index="${index}"]`);

    if (source) {
      while (source.firstChild) {
        target.appendChild(source.firstChild);
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.js-header');
  const headerMenu = document.querySelector('.js-header-menu');
  const rootLis = headerMenu.querySelectorAll(':scope > li');

  let leaveTimeout;

  rootLis.forEach(li => {
    li.addEventListener('mouseenter', () => {
      clearTimeout(leaveTimeout);

      const hasMegamenu = li.querySelector('.js-megamenu-container');

      if (hasMegamenu) {
        header.classList.add('with-hover-menu');
        rootLis.forEach(menu => menu.classList.remove('show'));
        li.classList.add('show');
      } else {
        leaveTimeout = setTimeout(() => {
          const isOnMegamenu = [...rootLis].some(item =>
            item.querySelector('.js-megamenu-container') && item.matches(':hover')
          );

          if (!isOnMegamenu) {
            rootLis.forEach(menu => menu.classList.remove('show'));
            header.classList.remove('with-hover-menu');
          }
        }, 300);
      }
    });

    li.addEventListener('mouseleave', () => {
      leaveTimeout = setTimeout(() => {
        const isOnMegamenu = [...rootLis].some(item =>
          item.querySelector('.js-megamenu-container') && item.matches(':hover')
        );

        if (!isOnMegamenu) {
          rootLis.forEach(menu => menu.classList.remove('show'));
          header.classList.remove('with-hover-menu');
        }
      }, 300);
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const mobileMenus = document.querySelectorAll('.js-get-mobile-megamenu');

  mobileMenus.forEach(mobileMenu => {
    const index = mobileMenu.getAttribute('data-index');
    const desktopMenu = document.querySelector(`.js-get-megamenu[data-index="${index}"]`);

    if (desktopMenu) {
      const matchingDivs = desktopMenu.querySelectorAll('div[id*="megamenu_links"]');

      if (matchingDivs.length > 0) {        
        mobileMenu.classList.add('with-mobile-sub-menu');

        const mobileSubMenu = document.createElement('div');
        mobileSubMenu.classList.add('mobile-submenu');

        matchingDivs.forEach(div => {
          mobileSubMenu.appendChild(div.cloneNode(true));
        });

        mobileMenu.insertAdjacentElement('afterend', mobileSubMenu);
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-toggle-mobile-megamenu').forEach(toggle => {
    toggle.addEventListener('click', (event) => {
      const liParent = toggle.closest('li');
      const submenu = liParent.querySelector('.mobile-submenu');
      if (!submenu) return;

      event.preventDefault();

      if (!submenu.classList.contains('display')) {
        const initialHeight = liParent.offsetHeight;
        liParent.dataset.initialHeight = initialHeight;
        liParent.style.height = initialHeight + 'px';

        submenu.classList.add('display');
        toggle.classList.add('active');

        setTimeout(() => {
          submenu.classList.add('show');
          const expandedHeight = liParent.scrollHeight;

          requestAnimationFrame(() => {
            liParent.style.transition = 'height 0.3s ease';
            liParent.style.height = expandedHeight + 'px';
          });
        }, 10);
      } else {
        const initialHeight = liParent.dataset.initialHeight || 'auto';
        const currentHeight = liParent.offsetHeight;

        liParent.style.height = currentHeight + 'px';
        liParent.style.transition = 'height 0.3s ease';

        submenu.classList.add('closing');
        toggle.classList.remove('active');

        setTimeout(() => {
          liParent.style.height = initialHeight + 'px';

          setTimeout(() => {
            liParent.style.height = '';
            liParent.style.transition = '';
            submenu.classList.remove('display', 'show', 'closing');
          }, 300);
        }, 10);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.querySelector('.js-open-mobile-menu');
  const closeBtn = document.querySelector('.js-close-mobile-menu');
  const mobileMenu = document.querySelector('.js-mobile-menu');

  if (openBtn && mobileMenu) {
    openBtn.addEventListener('click', (event) => {
      event.preventDefault();
      mobileMenu.classList.add('display');
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        mobileMenu.classList.add('show');
      }, 50);
    });
  }

  if (closeBtn && mobileMenu) {
    closeBtn.addEventListener('click', () => {
      mobileMenu.classList.add('closing');

      setTimeout(() => {
        mobileMenu.classList.remove('closing', 'show', 'display');
        document.body.style.overflow = 'visible';
      }, 300);
    });
  }

  document.querySelectorAll('.js-go-to-notification').forEach(button => {
    button.addEventListener('click', () => {
      const index = button.getAttribute('data-index');

      const container = document.querySelector('.js-notifications-container');
      if (container) {
        container.classList.add('active');
      }

      document.querySelectorAll('.js-full-notification').forEach(notification => {
        if (notification.getAttribute('data-index') === index) {
          notification.classList.add('active');
        } else {
          notification.classList.remove('active');
        }
      });
    });
  });

  document.querySelectorAll('.js-go-back-to-notifications').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const container = document.querySelector('.js-notifications-container');
      if (container) {
        container.classList.remove('active');
      }
    });
  });

  const openNotificationsBtn = document.querySelector('.js-open-notifications');
  const notificationsPanel = document.querySelector('.js-notifications');

  if (openNotificationsBtn && notificationsPanel) {
    openNotificationsBtn.addEventListener('click', (event) => {
      event.preventDefault();
      notificationsPanel.classList.add('display');
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        notificationsPanel.classList.add('show');
      }, 50);
    });
  }

  document.querySelectorAll('.js-close-notifications').forEach(closeBtn => {
    closeBtn.addEventListener('click', (event) => {
      event.preventDefault();
      if (notificationsPanel) {
        notificationsPanel.classList.add('closing');

        setTimeout(() => {
          notificationsPanel.classList.remove('closing', 'show', 'display');
          document.body.style.overflow = 'visible';
        }, 300);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.js-header');

  if (!header) return;

  const openers = ['.js-open-mobile-menu', '.js-open-notifications'];
  const closers = ['.js-close-mobile-menu', '.js-close-notifications'];

  openers.forEach(selector => {
    document.querySelectorAll(selector).forEach(button => {
      button.addEventListener('click', () => {
        header.classList.add('with-opening');
      });
    });
  });

  closers.forEach(selector => {
    document.querySelectorAll(selector).forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          header.classList.remove('with-opening');
        }, 300);
      });
    });
  });
});

function animatePath(line, toX, duration = 300) {
  const d = line.getAttribute('d');
  const match = d.match(/H([\d.]+)/);
  const fromX = match ? parseFloat(match[1]) : 12.0859; 

  const start = performance.now();

  function step(timestamp) {
    const progress = Math.min((timestamp - start) / duration, 1);
    const currentX = fromX + (toX - fromX) * progress;
    line.setAttribute('d', `M1 6.69414H${currentX}`);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}

document.addEventListener('mouseover', (event) => {
  const button = event.target.closest('.js-shop-now');
  if (!button) return;

  const lines = button.querySelectorAll('.line');
  lines.forEach(line => {
    animatePath(line, 22.0859);
  });
});

document.addEventListener('mouseout', (event) => {
  const button = event.target.closest('.js-shop-now');
  if (!button) return;

  const lines = button.querySelectorAll('.line');
  lines.forEach(line => {
    animatePath(line, 12.0859);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const logo = document.querySelector('.js-fixed-video-logo');
  if (!logo) return;

  const updateLogoPosition = () => {
    if (window.innerWidth <= 991) {
      logo.style.bottom = '0px';
      return;
    }

    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const bodyHeight = document.body.offsetHeight;

    const bottomSpace = bodyHeight - (scrollY + windowHeight);

    if (bottomSpace > 100) {
      logo.style.bottom = '0px';
    } else {
      logo.style.bottom = `${100 - bottomSpace}px`;
    }
  };

  updateLogoPosition();
  window.addEventListener('scroll', updateLogoPosition);
  window.addEventListener('resize', updateLogoPosition);
});